import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { HaldorBlockConsumer, SkolonBlock } from '@haldor/ui';
import AssignmentBlock from './Blocks/AssignmentBlock';
import FileBlock from './Blocks/FileBlock';
import LinksBlock from './Blocks/LinksBlock';
import NDLABlock from './Blocks/NdlaBlock';

var BlockConsumer = /*#__PURE__*/function (_Component) {
  _inherits(BlockConsumer, _Component);

  var _super = _createSuper(BlockConsumer);

  function BlockConsumer() {
    _classCallCheck(this, BlockConsumer);

    return _super.apply(this, arguments);
  }

  _createClass(BlockConsumer, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(HaldorBlockConsumer, _extends({
        plugins: [LinksBlock, AssignmentBlock, FileBlock, SkolonBlock, NDLABlock]
      }, this.props));
    }
  }]);

  return BlockConsumer;
}(Component);

export default BlockConsumer;